// extracted by mini-css-extract-plugin
export default {"products":"tx-z","card":"ux-z","oosMessaging":"vx-z"};